import $ from 'jquery';
import _ from 'underscore';
import noUiSlider from 'nouislider';
import Animation from 'modules/animation/animation';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-slider-range',
			dom: {
				control: '.js-slider-range-control',
				labels: '.js-slider-range-labels',
				label: '.js-slider-range-label',
				slider: '.js-slider-range-slider',
				roll: '.js-slider-range-roll',
				template: '.js-slider-range-template'
			},
			rates: [],
			base: false,
			callback: {
				update: false
			},
			colors: {
				start: [205, 34, 110],
				edit: [-205, 139, 128]
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.rates = this.options.rates;
		this.base = this.options.base;
		this.animation = false;
		this.position = false;
		self.inited = false;
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		return this;
	}

	getDom() {
		this.$control = this.$el.find(this.options.dom.control);
		this.$label = this.$el.find(this.options.dom.label);
		this.$slider = this.$el.find(this.options.dom.slider);
		this.slider = this.$slider[0];
		this.$roll = this.$el.find(this.options.dom.roll);
		return this;
	}

	rollDom() {
		this.$handle = this.$slider.find('.noUi-handle');
		this.$origin = this.$slider.find('.noUi-origin');
		this.$handle.append(this.$roll);
		this.origin = new Animation({el: this.$origin});
		return this;
	}

	animate() {
		const self = this;
		let base = parseInt(self.$origin[0].style.left);
		const min = (base - 25 < 0) ? 0 : base - 25;
		let max = (base + 25 > 100) ? 100 : base + 25;

		self.$origin.addClass('animate');
		self.$origin.css('left', min + '%');
		self.animation = setInterval(function () {
			if (max !== false) {
				self.$origin.css('left', max + '%');
				max = false;
			} else if (base !== false) {
				self.$origin.css('left', base + '%');
				base = false;
			} else {
				self.$origin.removeClass('animate');
				clearInterval(self.animation);
			}
		}, 750);
	}

	buildLabels(labels, tobase) {
		this.$labels = this.$el.find(this.options.dom.labels);
		this.$template = this.$el.find(this.options.dom.template);
		this.template = _.template(this.$template.html().trim());

		this.$labels.html(this.template({labels: labels}));
		if (tobase) {
			this.$labels.appendTo(this.$slider.find('.noUi-base'));
		}

		this.$label = this.$el.find(this.options.dom.label);
		return this;
	}

	getRate(value, type = 'price') {
		const self = this;
		const getType = type;
		const getValue = value;
		let rate = false;
		let key = false;
		$.each(self.rates, function (rateKey, rateItem) {
			if (rateItem[getType] == getValue) {
				rate = rateItem;
				key = rateKey;
			}
		});
		return {key, rate};
	}

	onSlide(value) {
		this.setColor(value);
		value = Math.round(value);
		this.$label.removeClass('active').eq(value).addClass('active');
		if (this.position !== value) {
			this.position = value;
			if (typeof this.options.callback.update === 'function') {
				this.options.callback.update(this.position, this.rates[this.position]);
			}
		}
	}

	setColor(value) {
		const factor = value <= this.rates.length * 0.8 ? value / (this.rates.length * 0.8) : 1;
		const start = this.options.colors.start;
		const edit = this.options.colors.edit;
		const background = 'rgb(' +
				parseInt(start[0] + (edit[0] * factor)) + ',' +
				parseInt(start[1] + (edit[1] * factor)) + ',' +
				parseInt(start[2] + (edit[2] * factor)) +
			')';
		this.$slider.css({'background-color': background});
	}

	set(key) {
		this.slider.noUiSlider.set(key);
		return this;
	}

	setPrice(value) {
		const data = this.getRate(value, 'price');
		this.set(data.key);
		return this;
	}

	setAncor(value) {
		const data = this.getRate(value, 'ancor');
		this.set(data.key);
		return this;
	}

	onLabel(event) {
		const $target = $(event.currentTarget);
		const {js} = $target.data();
		if (js >= 0) {
			this.set(js);
		} else {
			this.set(this.rates.length - 1);
		}
	}

	update(data) {
		this.options = $.extend(true, {}, this.options, data);
		this.base = this.options.base;
		const value = this.getRate(this.base).key;
		if (value !== this.position && this.inited) {
			this
				.set(value)
				.onSlide(value);
		}
		return this;
	}

	onControl(event) {
		const $target = $(event.currentTarget);
		const {js} = $target.data();
		let set = this.position;
		if (js == 'plus' && set + 1 <= this.rates.length - 1) {
			set++;
		}
		if (js == 'minus' && set - 1 >= 0) {
			set--;
		}
		this.set(set);
	}

	render() {
		const self = this;
		if (self.$el.length) {
			self.getDom();
			noUiSlider.create(this.slider, {
				start: self.getRate(self.base).key,
				animate: true,
				connect: 'lower',
				range: {
					min: 0,
					max: self.rates.length - 1
				}
			});
			self.rollDom();

			self.slider.noUiSlider.on('update', function () {
				const value = self.slider.noUiSlider.get();
				self.onSlide(value);
				clearInterval(self.animation);
				self.$origin.removeClass('animate');
			});

			self.slider.noUiSlider.on('set', function () {
				clearInterval(self.animation);
				self.$origin.removeClass('animate');
				const value = self.slider.noUiSlider.get();
				if (value != Math.round(value)) {
					self.slider.noUiSlider.set(Math.round(value));
				}
			});

			self.slider.noUiSlider.on('end', function () {
				const value = self.slider.noUiSlider.get();
				if (value != Math.round(value)) {
					self.slider.noUiSlider.set(Math.round(value));
				}
			});

			self.$label.on('click', self.onLabel.bind(this));
			self.$control.on('click', self.onControl.bind(this));

			self.inited = true;
			// setTimeout(function () {
			// 	self.animate();
			// }, 1500);
		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/blocks/slider-range/slider-range.js